<template>
  <div class="farm-window farm-list-card events-card" :style="cssVars">
    <h2>News</h2>
    <div class="farm-list event-list">
      <div v-for="event in farm.state.eventManager.events" class="farm-window farm-list-entry event-entry">
        <div>
          <p>{{ util.currentDate(event.time) }}</p>
        </div>
        <div class="event-text">
          <p>{{ event.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Employee from '@/employee/Employee'
import Farm from '@/farm/Farm'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'

@Options({
  components: {
    ValueMeter, TextButton
  },
  props: {
    employee: Employee, farm: Farm
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  },
  computed: {
    cssVars() {
      return {
        '--background-image': 'url(' + require('@/assets/wolfgang-hasselmann.jpg') + ')'
      }
    },
    util() {
      return util
    }
  }
})
export default class EventsCard extends Vue {
  farm!: Farm
}
</script>

<style scoped lang="scss">
  .events-card {
    display: grid;
    width: 100%;
    min-height: 50vh;
  }

  .event-list {
    grid-area: c;

    overflow-y: auto;
  }

  .event-entry {
    display: grid;
    grid-template-columns: 2fr 6fr;
    min-height: 50px;
    padding: 0;
    text-align: center;

    & > div {
      display: grid;

      &:nth-child(1) {
        border-right: $component-border-style;
        background-color: #541A32;
      }
    }

    .event-text {
      text-align: left;
      padding: 5px 10px 5px 10px;
    }
  }

  .stat-bars {
    display: grid;
    grid-template-columns: 100px 1fr;
    grid-auto-rows: 40px;
    grid-gap: 10px;
    margin-bottom: 1em;

    .value-meter {
      margin-top: auto;
      margin-bottom: auto;
      height: 80%;
    }

    p {
      margin-top: auto;
      margin-bottom: auto;
    }
  }

  .option-buttons {
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-flow: column;

    p {
      text-align: center;
    }

    .text-button {
      display: table;
      margin-top: auto;
      margin-bottom: auto;
      height: 80%;
      border: $component-border-style;
      border-right: 0;

      &:last-child {
        border: $component-border-style;
      }

      p {
        display: table-cell;
        vertical-align: middle;
      }
    }

    .selected-button {
      background-color: scale-color(darken($highlight-color, 10%), $saturation: -10%);
      //border-color: $highlight-color;
      p {
        //color: $highlight-color;
      }
    }
  }

  .table-div {
    overflow-x: auto;
    margin-left: auto;
    margin-right: auto;
    width: min-content;
    padding: 10px;

    h2 {
      margin-bottom: 0;
    }
  }

  .styled-table {
    border-collapse: collapse;
    font-size: 0.9em;
    font-family: sans-serif;
    min-width: 400px;

    th, td {
      padding: 12px 15px;
    }

    thead {
      tr {
        background-color: $component-base-color;
        color: #ffffff;
        text-align: left;
      }

      th {
        max-width: 100px;
      }

    }

    tbody {
      .tier-2 {
        padding-left: 30px;
      }

      tr {
        border-bottom: 1px solid #eee;
      }

      tr:nth-child(odd) {
        background-color: rgba(#ddd, 0.5);
      }

      tr:nth-child(even) {
        background-color: rgba(#222, 0.5);
      }

      tr:last-of-type {
        border-top: 4px solid $component-base-color;
        border-bottom: 8px solid $component-base-color;
      }
    }
  }

  .table-header {
    text-align: left;
  }

  .name-cell {
    text-align: left;
  }

  .number-cell {
    text-align: right;
  }

</style>
